module.exports = __webpack_public_path__ + "static/media/styled-components.8a2de018.svg";